var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6327 4.48396C18.449 3.99496 19.102 3.17997 19.4286 2.20198C18.6122 2.69098 17.7143 3.01697 16.8163 3.17997C15.2653 1.54999 12.6531 1.46849 11.0204 3.01697C10.2041 3.75047 9.71429 4.89145 9.71429 6.03244C9.71429 6.35844 9.71429 6.68444 9.79592 6.92893C6.53061 6.76593 3.42857 5.21745 1.38776 2.69098C0.326531 4.48396 0.897959 6.84743 2.69388 8.06992C2.04082 8.06992 1.38776 7.90692 0.816327 7.58093V7.66243C0.816327 9.61841 2.20408 11.2484 4.08163 11.6559C3.5102 11.8189 2.85714 11.8189 2.20408 11.7374C2.77551 13.3674 4.2449 14.5084 6.04082 14.5899C4.57143 15.7308 2.77551 16.3828 0.979592 16.3828C0.653061 16.3828 0.326531 16.3828 0 16.3013C1.87755 17.4423 4.08163 18.0943 6.28571 18.0943C12.6531 18.1758 17.8776 12.9599 17.9592 6.60294V5.95094C18.7755 5.38045 19.4286 4.64696 20 3.83197C19.2653 4.15796 18.449 4.40246 17.6327 4.48396Z",
    fill: "#0D111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0a1b7627.svg";
export { ForwardRef as ReactComponent };